import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a74faf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pr-registration__content basic-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Estamos muito felizes com seu interesse em atender na orienteme!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Caso não encontre esse email, procure no Spam ou na sua lixeira."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Se mesmo assim não encontrar entre em contato pelo email "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:suporte@orienteme.com.br" }, "suporte@orienteme.com.br")
], -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Ficamos realmente felizes com sua inscrição. Em breve entraremos em contato com informações sobre os próximos passos. ", -1))
const _hoisted_8 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, "Obrigado " + _toDisplayString(_ctx.name), 1),
    (_ctx.firstThankYou)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", null, [
            _createTextVNode(" Seu cadastro já foi enviado para nosso time de " + _toDisplayString(_ctx.segment) + ".", 1),
            _hoisted_4,
            _createTextVNode(" Você receberá um email com os próximos passos e um link para enviar suas informações profissionais e sua experiência. ")
          ]),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (!_ctx.firstThankYou)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("p", null, " Caso tenha alguma dúvida, ou precisar de mais informações, entre em contato com nosso time de " + _toDisplayString(_ctx.segment) + ", pelo email suporte@orienteme.com.br ", 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider, { style: {"margin-top":"50px"} }),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.goToWebSite
      }, {
        default: _withCtx(() => [
          _createTextVNode(" VOLTAR PARA O SITE ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}